import { useEffect, useState } from "react";

export function useVersionChecker(interval = 60000) {
  const [isNew, setIsNew] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(
    localStorage.getItem("app_version") || null);

  useEffect(() => {
    let timer;
    const checkVersion = async () => {
      const res = await fetch(`/version.json?_=${Date.now()}`);
      const data = await res.json();
      if (!currentVersion) {
        setCurrentVersion(data.version);
      } else if (data.version !== currentVersion) {
        setIsNew(true);
        setCurrentVersion(data.version);
      }
      localStorage.setItem("app_version", data.version);
    };
    checkVersion();
    timer = setInterval(checkVersion, interval);
    return () => clearInterval(timer);
  }, [currentVersion]);

  return { isNew, currentVersion };
}
